module.exports = __webpack_public_path__ + "img/1_7_1.98819809.jpg";